import { ReactNode, useEffect } from 'react'
import styled from 'styled-components'
import {
  CompanyInformation_CompanyInformationFragment,
  CompanyInformationNotCachedQuery_CompanyInformationFragment,
  useGqlCompanyInformationNotCachedQueryQuery,
  useGqlViewCompanyMutation,
} from 'generated/graphql'
import DetailOverviewRelated from '../contents/DetailOverviewRelated'
import CompanyInfoDetailHeader from '../header/CompanyInfoDetailHeader'
import CompanyInfoDetailTabs from '../tabs/CompanyInfoDetailTabs'

interface CompanyInfoDetailLayoutDesktopProps {
  companyInformation: CompanyInformation_CompanyInformationFragment
  children: ReactNode
}

const CompanyInfoDetailLayoutDesktop = ({
  companyInformation,
  children,
}: CompanyInfoDetailLayoutDesktopProps) => {
  const [viewCompany] = useGqlViewCompanyMutation()

  useEffect(() => {
    if (companyInformation?.companyId) {
      viewCompany({
        variables: { companyId: companyInformation?.companyId || '' },
      })
    }
  }, [viewCompany, companyInformation?.companyId])

  const { data: csrData } = useGqlCompanyInformationNotCachedQueryQuery({
    variables: { companyInformationId: companyInformation?.id || '' },
    fetchPolicy: 'cache-and-network',
    skip: !companyInformation,
  })

  const mergedData: Partial<
    CompanyInformation_CompanyInformationFragment &
      CompanyInformationNotCachedQuery_CompanyInformationFragment
  > = {
    ...companyInformation,
    viewerInterestedIn: csrData?.companyInformation?.viewerInterestedIn,
    company: {
      ...companyInformation.company,
      interestCount: csrData?.companyInformation?.company?.interestCount || 0,
      viewCount: csrData?.companyInformation?.company?.viewCount || 0,
      shareCount: csrData?.companyInformation?.company?.shareCount || 0,
    },
  }

  return (
    <StyledWrapper>
      <CompanyInfoDetailHeader data={mergedData} />
      <CompanyInfoDetailTabs companyId={companyInformation.companyId} />
      <StyledContentWrapper>
        {children}
        <DetailOverviewRelated companyId={companyInformation.companyId} />
      </StyledContentWrapper>
    </StyledWrapper>
  )
}

export default CompanyInfoDetailLayoutDesktop

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const StyledContentWrapper = styled.div`
  width: 100%;
  background-color: #f5f6f8;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 0 68px;

  section {
    padding: 32px !important;
  }
`
